import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Anzeige Text.
     */
    text: string;

    /**
     * Das zugeordnete Jahr.
     */
    year: number;

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: ( year: number) => void;
}

export class YearItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { year, onClick } = this.props;
        onClick && onClick(year);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <div
                className="datepicker_years_item"
                style={this.props.style}
                onClick={this.onClick}>
                {this.props.text}
            </div>
        );
    }
}